<nz-spin [nzSpinning]="loading$ | async">
  <form
    [formGroup]="form"
    nz-form
    class="add-org-form form"
    nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <h3 class="title s-16 mb-16">
        {{ drawerParmas.selectedDay }},
        {{ drawerParmas.selectedDate | date: 'MMMM dd, yyyy' }}
      </h3>
      <nz-form-item>
        <nz-form-label nzFor="interval1">Interval 1</nz-form-label>
        <nz-form-control>
          <input
            type="text"
            nz-input
            [mask]="'00'"
            [validation]="false"
            formControlName="interval1"
            placeholder="Enter value"
            (input)="validateInput($event)" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="interval2">Interval 2</nz-form-label>
        <nz-form-control>
          <input
            type="text"
            nz-input
            [mask]="'00'"
            [validation]="false"
            formControlName="interval2"
            placeholder="Enter value"
            (input)="validateInput($event)" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="interval3">Interval 3</nz-form-label>
        <nz-form-control>
          <input
            type="text"
            [mask]="'00'"
            [validation]="false"
            nz-input
            formControlName="interval3"
            placeholder="Enter value"
            (input)="validateInput($event)" />
        </nz-form-control>
      </nz-form-item>
      <div class="error-text mt-3" *ngIf="!isIntervalFormValid">
        Please enter at least 1 value.
      </div>
      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <div class="display-flex button-group-gap">
          <button
            nz-button
            type="button"
            nzType="primary"
            (click)="submitForm()"
            [disabled]="!isIntervalFormValid">
            Save & Close
          </button>
          <button
            *ngIf="hasNextDate"
            nz-button
            type="button"
            nzType="primary"
            (click)="submitAndNext()"
            [disabled]="!isIntervalFormValid">
            Save & Next
          </button>
        </div>
      </div>
    </div>
  </form></nz-spin
>
